import classNames from 'classnames';

import { ImageFragmentFragment, LinkFragmentFragment } from '../../../__generated__/graphql';
import AppImage from '../../../components/AppImage';
import ButtonLink from '../../../components/Button/ButtonLink';
import { Heading4, Paragraph } from '../../../components/Text';

import style from './benefit-card.module.css';

interface BenefitCardProps {
  buttonId: string;
  buttonLinkFragment: LinkFragmentFragment | null | undefined;
  className: string;
  description: string;
  image: ImageFragmentFragment | null | undefined;
  title: string;
}

const BenefitCard = ({
  buttonId,
  buttonLinkFragment,
  className,
  description,
  image,
  title,
}: BenefitCardProps) => {
  return (
    <article className={classNames(style.benefitCard, className)}>
      {image && (
        <AppImage
          className={style.image}
          fallbackHeight={223}
          fallbackWidth={400}
          image={image}
        />
      )}

      <Heading4
        className={style.title}
        fontColor="turquoise"
        uppercase
      >
        {title}
      </Heading4>

      <Paragraph fontSize={15}>
        {description}
      </Paragraph>

      <ButtonLink
        buttonColor="white"
        className={style.learnMoreButton}
        id={buttonId}
        linkFragment={buttonLinkFragment}
      />
    </article>
  );
};

export default BenefitCard;
